<button class="edit-field-inline-delete-button"
        mat-menu-item
        type="button"
        (click)="confirmDelete()">
  <span translate="TRANS__DELETE_ITEM__DELETE"></span>
</button>
